import React, { Component } from 'react';
import styled from 'styled-components';
import { Box, Button, Card, Flex, Heading } from 'rebass';
import { Formik, Form } from 'formik';
import TextInput from '../components/TextInput';
import { FormField } from '../components/FormField';
import { ADMIN_SET_MOBILE_USER_WEEK } from '../graphql';
import { compose, withApollo } from 'react-apollo';
import { withToastManager } from 'react-toast-notifications/dist/ToastProvider';
import CheckboxInput from '../components/CheckboxInput';

const Container = styled(Box)`
  max-width: 900px;
  width: 100%;
  margin: 0 auto;
  text-align: center;
  padding-top: 48px;
`;

class AdminSetMobileUserWeek extends Component {
  handleSubmit = async (values, actions) => {
    actions.setSubmitting(true);
    try {
      const res = await this.props.client.mutate({
        mutation: ADMIN_SET_MOBILE_USER_WEEK,
        variables: {
          email: values.email,
          weeknumber: values.weekNumber,
          insertFakeSymptomsTrackValues: values.insertFakeSymptomsTrackValues
        },
      });
// console.log('res', res)

      if (res && res.data && res.data.adminSetMobileUserWeek) {
        if (res.data.adminSetMobileUserWeek.ok === true) {
          actions.resetForm();
          this.props.toastManager.add('Updated successfully', {
            appearance: 'success',
          });
        } else {
          this.props.toastManager.add(
            
              'Error updating',
            { appearance: 'error' }
          );
        }
      } else {
        actions.setSubmitting(false);
        this.props.toastManager.add('Error updating, please try again', {
          appearance: 'error',
        });
      }

      actions.setSubmitting(false);
      //   toastManager.add('Error submitting intake form', { appearance: 'error' });
    } catch (err) {
      actions.setSubmitting(false);
      this.props.toastManager.add('Error updating, please try again', {
        appearance: 'error',
      });
    }
  };

  render() {
    return (
      <Container>
        <Flex m={[3, 5]} flex={1} flexDirection="column">
          <Heading mb={4} mt={[3, 0]} ml={[1, 0]} fontSize={[4, 5]}>
            Set Mobile User current week.
          </Heading>
          <Card mb={4} p={[3, 4]}>
            <Flex flexDirection={'column'} flex={1} alignItems="center">
              <Formik
                initialValues={{ email: '', weekNumber: 1,insertFakeSymptomsTrackValues:false }}
                // validationSchema={schema}
                onSubmit={(values, actions) =>
                  this.handleSubmit(values, actions)
                }
                render={({
                  errors,
                  touched,
                  isValid,
                  isSubmitting,
                  handleChange,
                  handleBlur,
                  values,
                }) => (
                  <Form style={{ width: '300px' }}>
                    <Flex flexDirection="column" flex={1}>
                      <Heading mb={4}>Patient's Email</Heading>
                    </Flex>
                    <FormField mb={4} error={touched.email && errors.email}>
                      <TextInput
                        placeholder="Email Address"
                        type="email"
                        name="email"
                      />
                    </FormField>
                    <Flex flexDirection="column" flex={1}>
                      <Heading mb={4}>Week Number</Heading>
                    </Flex>
                    <FormField
                      mb={4}
                      error={touched.weekNumber && errors.weekNumber}
                    >
                      <TextInput
                        placeholder="Current user week"
                        name="weekNumber"
                        type="number"
                      />
                    </FormField>
                    <FormField mb={4} error={touched.phone && errors.phone}>
                      <label for="insertFakeSymptomsTrackValues">
                        Emulate fake symptom tracking?
                      </label>
                      <CheckboxInput
                        name="insertFakeSymptomsTrackValues"
                        styles={{
                          checked: {
                            Box: {
                              backgroundColor: 'rgb(54, 79, 121)',
                            },
                          },
                        }}
                      />
                    </FormField>
                    <Button
                      mt={4}
                      mb={4}
                      variant="primary"
                      width={1 / 2}
                      disabled={!isValid || isSubmitting}
                      type="submit"
                    >
                      Change
                    </Button>
                  </Form>
                )}
              />
            </Flex>
          </Card>
        </Flex>
      </Container>
    );
  }
}

export default compose(
  withApollo,
  withToastManager
)(AdminSetMobileUserWeek);
